// @ts-nocheck
/* eslint-disable camelcase */
import * as React from 'react';
import CourseCard from 'components/CourseCard/index';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { getUtmContent } from 'utils/slug';
import dashboardActions from 'ducks/dashboard/actions';
import { teamActions } from 'ducks/team/actions';
import { courseActions } from 'ducks/courses/actions';
import { useSavedProgramsWatch, useUserHasOneTeam, useSaveContent } from 'utils/customHooks';
import { Wrapper, ProgramsTitle, CardContainer, ProgramsSubTitle } from './Programs.styles';
import type { ProgramsProps } from './Programs.types';

const renderDegreePrograms = (logo, text, programs, pathname, handler): React.ReactElement<any>[] =>
  programs?.map(
    ({
      id,
      attributes: { program_name, slug, cover_image_file, school, url, modality, degree_type },
    }) => {
      const utmUrl = `${url}&utm_campaign=university_landing_page&utm_content=${getUtmContent(
        pathname,
      )}&utm_term=card`;
      const university = school?.data?.attributes?.university;
      return (
        <CourseCard
          url={utmUrl}
          key={id}
          linkOut
          id={id}
          title={program_name}
          image={cover_image_file?.url}
          description={text}
          courseLogo={university?.logo?.url || university?.image?.url}
          slug={slug}
          checked={false}
          hideSaveButton
          modality={modality}
          degreeType={degree_type}
          onChange={handler}
          schoolName={university?.name}
        />
      );
    },
  );

export const Programs = ({ logo, text, programs }: ProgramsProps): React.ReactElement<any> => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const { data: savedPrograms } = useSelector((state) => state.partnerPrograms.savedPrograms);
  const pathname = useSelector((state) => state.router.location.pathname) || '';
  const isMoreThanOneTeam = useUserHasOneTeam();
  const [currentCourse, setCurrentCourse] = React.useState(null);
  useSaveContent(currentCourse?.attributes?.slug);
  useSavedProgramsWatch();

  const setSelectedCource = (id?: string): void => {
    if (id) {
      const item = savedPrograms.find((savedCourse) => savedCourse.id === id);
      dispatch(courseActions.selectCourse({ ...item, saves: item?.saves || [] }));
    }
  };

  const handleToggleCheckbox = (id: number): void => {
    if (!isLoggedIn) {
      history.push('/signup');
    } else {
      dispatch(dashboardActions.setModalAction('saveProgram'));
      const current = programs.find((item) => item.id === id);
      setCurrentCourse(current);
      setSelectedCource(current?.attributes?.slug);

      if (isMoreThanOneTeam) {
        dispatch(
          teamActions.toggleSelectTeamModal({
            isOpen: true,
            isSaveMode: true,
            isTeamModalSaveOrUnsaveMode: true,
          }),
        );
      }
    }
  };

  return (
    <Wrapper>
      <ProgramsTitle>Programs</ProgramsTitle>
      <div>
        <ProgramsSubTitle>Degree Programs</ProgramsSubTitle>
        <CardContainer>
          {renderDegreePrograms(logo, text, programs, pathname, handleToggleCheckbox)}
        </CardContainer>
      </div>
    </Wrapper>
  );
};
